import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-icon',
    imports: [CommonModule],
    templateUrl: './icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './icon.component.scss'
})
export class IconComponent implements OnChanges{

  @Input() public iconLabel?: string;
  @Input() public isPointer: boolean | undefined = true;

  public svgIcon: any;

  constructor() {}

  public ngOnChanges(): void {
    this.svgIcon = '/assets/icons/' + this.iconLabel + '.svg';
  }
}
